import { Component } from '@theme/component';

/**
 * Product page buy box that sticks beside the gallery without hiding its own bottom.
 *
 * A plain `position: sticky; top: <header>` box taller than the viewport pins its top and leaves
 * the rest below the fold until the gallery runs out, so the lower tabs and "Complete the perfect
 * pair" stay out of reach (and, inside the `.page-wrapper` scroller, the recommendations observer
 * never sees them to load). Publishing the box height lets the CSS lower `top` below zero: a tall
 * box scrolls with the page until its bottom shows, then sticks there. A box that fits sticks at
 * the header as before.
 */
class OudhStickyAside extends Component {
  #observer = new ResizeObserver(() => {
    this.style.setProperty('--oudh-aside-height', `${this.offsetHeight}px`);
  });

  connectedCallback() {
    super.connectedCallback();
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.#observer.disconnect();
  }
}

if (!customElements.get('oudh-sticky-aside')) {
  customElements.define('oudh-sticky-aside', OudhStickyAside);
}
